import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  IN_ROOM_DINING_ADDONS_CREATE,
  IN_ROOM_DINING_ADDONS_EDIT,
  IN_ROOM_DINING_ADDONS_VIEW,
  IN_ROOM_DINING_ADDON_ALREADY_OCCUPIED_ERROR,
} from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import {
  inRoomDiningAddOnSelector,
  fetchAllInRoomDining,
  inRoomDiningItemsSelector,
  inRoomDiningCombosSelector,
  setInRoomDiningAddOn,
} from '../../../servicesSlice';
import {
  allHotelsSelector,
  selectedHotelCurrencySelector,
} from '../../../../property/propertySlice';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import { AddCircle, DragIndicator, MoreHoriz } from '@material-ui/icons';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Menu,
  MenuItem,
  Checkbox,
} from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import {
  deactivateInRoomDiningAddOn,
  deleteInRoomDiningAddOn,
  activateInRoomDiningAddOn,
  uploadIRDAddOnsByCSV,
  deleteSelectedItems,
  updateSelectedItemsStatus,
  addInRoomDiningAddOn,
} from '../../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import WarningPopup from '../../../../../shared/warning-popup/Warning-Popup';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import {
  getCheckedIds,
  updateCheckedStatus,
  updateSelectedModule,
  validateAlphanumeric,
  generateConfirmationMessage,
  selectedCheckList,
  ResetFilterList,
  PARTIAL_CHECKBOX_GREEN,
  isDragDisabled,
} from '../../../../../utils/formUtils';
import { Dialog } from '@mui/material';
import CsvUploader from '../../../../../shared/csv-uploader/Csv-Uploader';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { DOWNLOAD_ASSETS_URL } from '../../../../../env/Configurations';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const initialState = {
  name: '',
  description: '',
  status: false,
};

const AddonsListView = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    hotelId,
    restaurantId,
    inRoomDiningLoader,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
    isHideAddButton = false,
  } = props;
  const dispatch = useDispatch();
  const selectedHotel = useSelector(allHotelsSelector);
  const inRoomDiningAddOns = useSelector(inRoomDiningAddOnSelector);
  const inRoomDiningItems = useSelector(inRoomDiningItemsSelector);
  const inRoomDiningCombos = useSelector(inRoomDiningCombosSelector);
  const currency = useSelector(selectedHotelCurrencySelector);
  const [addOnsList, setAddOnsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
  });
  const [warningPopup, setWarningPopup] = useState(initialState);
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(hotelId);
  const [popUp, setPopUp] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [uploadState, setUploadState] = useState(false);
  const [csvUploadStatus, setCsvUploadStatus] = useState(false);
  const [csvUploadErrorMsg, setCsvUploadErrorMsg] = useState(null);
  const [csvValidateError, setCsvValidateError] = useState(false);
  const [dataExistError, setDataExistError] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [actionName, setActionName] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);

  useEffect(() => {
    setAddOnsList((prevList) => {
      return inRoomDiningAddOns?.map((addOn) => {
        const isChecked = selectedCheckList(prevList, addOn.id);
        return {
          ...addOn,
          isChecked: isChecked,
        };
      });
    });
    setLoading(false);
    setSearchText('');
  }, [inRoomDiningAddOns]);

  const getCheckedAddonList = addOnsList?.filter((addon) => addon?.isChecked);
  const listOfAddonIds = getCheckedAddonList?.map((addon) => addon.id);
  const selectedAddonLength = getCheckedAddonList?.length;

  const handleSearchText = async (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(addOnsList, 'isChecked');
    const filteredRows = await inRoomDiningAddOns.filter((addOn) => {
      return addOn.name.toLowerCase().includes(searchText.toLowerCase());
    });
    onsetPage(0);
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    setAddOnsList(updatedCheckedList);
    if (searchText && (isAllSelected || selectedAddonLength > 0)) {
      setShowBulkSearchAlert(true);
    } else if (!searchText) {
      setShowBulkSearchAlert(false);
      setAddOnsList(ResetFilterList);
    }
  };

  const onOpenDrawer = (event, type) => {
    if (selectedAddonLength) {
      setAddOnsList(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.addOn);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      addOn: null,
    });
  };

  const handleCellMenuClick = (event, addOn) => {
    event.stopPropagation();
    if (selectedAddonLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: addOn.id,
        name: addOn.name,
        title: '',
        description: '',
        status: false,
        anchorEl: event.currentTarget,
        addOn,
      });
    }
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onClickDelete = (event) => {
    event.stopPropagation();
    if (checkUsageItems() || checkUsageCombos()) {
      setWarningPopup({
        name: selectedValue.name,
        description: 'The selected Add-On cannot be deleted as it is being added to a Menu/Item',
        status: true,
      });
    } else {
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Are you sure you want to delete',
        description: 'This action cannot be reversed',
        status: true,
        anchorEl: null,
      }));
    }
  };

  const checkUsageItems = () => {
    return inRoomDiningItems.some(
      (ird) =>
        (ird.addons.addons && ird.addons.addons.some((item) => item === selectedValue.id)) ||
        (ird.addons.groupedAddon &&
          ird.addons.groupedAddon.some((item) =>
            item.addons.some((addOn) => addOn === selectedValue.id),
          )),
    );
  };

  const checkUsageCombos = () => {
    return inRoomDiningCombos?.some(
      (combo) =>
        (combo?.addons?.addons &&
          combo?.addons?.addons?.some((item) => item === selectedValue?.id)) ||
        (combo?.addons?.groupedAddon &&
          combo?.addons?.groupedAddon?.some((group) =>
            group?.addons?.some((addOn) => addOn === selectedValue?.id),
          )),
    );
  };

  const onDeleteItem = async () => {
    try {
      dispatch(stepUpLoaderCount());
      if (hotelId && selectedValue.id) {
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        const payload = {
          id: selectedValue.id,
          hotelId: hotelId,
          restaurantId: restaurantId,
        };
        await deleteInRoomDiningAddOn(payload, language);
        dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        notificationManager('success', 'Add-on deleted successfully');
      }
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) {
        switch (e.graphQLErrors[0].message) {
          case IN_ROOM_DINING_ADDON_ALREADY_OCCUPIED_ERROR:
            setWarningPopup({
              name: selectedValue.name,
              description:
                'The selected Add-On cannot be deleted as it is being added to a Menu/Item',
              status: true,
            });
            break;
          default:
            notificationManager('danger', e.graphQLErrors[0].message);
            break;
        }
      } else {
        notificationManager('danger', 'Failed to delete Add-On');
      }
    } finally {
      dispatch(stepDownLoaderCount());
    }
    handleClose();
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteCancel = (event) => {
    handleClose();
  };

  const handleBulkSearchAlertClose = () => {
    setShowBulkSearchAlert(false);
    setSearchText('');
    setAddOnsList(
      inRoomDiningAddOns?.map((res) => ({
        ...res,
        isChecked: false,
      })),
    );
  };

  const onToggleStatus = async (e) => {
    e.stopPropagation();
    if (selectedValue.addOn && hotelId) {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      try {
        dispatch(stepUpLoaderCount());
        const payload = {
          id: selectedValue.addOn.id,
          hotelId: hotelId,
          restaurantId: restaurantId,
        };
        selectedValue.addOn.status
          ? await deactivateInRoomDiningAddOn(payload, language)
          : await activateInRoomDiningAddOn(payload, language);
        dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        notificationManager(
          'success',
          `Add-on ${selectedValue.addOn.status ? 'deactivated' : 'activated'} successfully`,
        );
      } catch (e) {
        if (e.graphQLErrors) {
          notificationManager('danger', e.graphQLErrors[0].message);
        } else {
          notificationManager('danger', 'Failed to update Add-ons status');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
    handleClose();
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onViewDetails = () => {
    onViewToggle(IN_ROOM_DINING_ADDONS_VIEW, true, selectedValue.addOn);
  };

  const onClickRowViewDetails = (addonItem, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(IN_ROOM_DINING_ADDONS_VIEW, true, addonItem);
    }
  };

  const onCloseWarning = () => {
    handleClose();
    setWarningPopup(initialState);
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleUploadDialogClose = (e) => {
    dispatch(fetchAllInRoomDining(hotelId, restaurantId));
    setCsvUploadStatus(null);
    setUploadState(false);
  };
  const onClickUpload = (e) => {
    setUploadState(true);
  };

  const isNumber = (n) => {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
  };

  const isValidStatus = (status) => {
    const tempStatus = status.toLowerCase().trim();
    return tempStatus === 'yes' || tempStatus === 'no';
  };

  const handleCsvFileData = (itemsLists) => {
    const isTemplateInstructionRow = (row) => {
      const values = Object.values(row).map((v) => String(v || '').toLowerCase().trim());
      const joined = values.join(' ');
      const instructionPatterns = [
        'character limit', 'mandatory', 'alphanumeric', 'alpha-numeric',
        'enter the', 'fill in', 'e.g.', 'example:', 'max characters',
        'max char', 'required field', 'this field', 'drop down', 'dropdown',
        'select from', 'free text', 'auto populate', 'auto-populate',
      ];
      if (values.some((s) => s.startsWith('*') && instructionPatterns.some((p) => s.includes(p)))) return true;
      if (instructionPatterns.filter((p) => joined.includes(p)).length >= 2) return true;
      return false;
    };
    const filteredItemList = itemsLists.filter((row) => !isTemplateInstructionRow(row));
    const errors = [];
    if (filteredItemList.length === 0) {
      errors.push('No data rows found in the uploaded file.');
      setValidationErrors(errors);
      setCsvValidateError(true);
      return;
    }
    filteredItemList.forEach((item) => {
      const rowNum = item.__rowNum || '?';
      const rowErrors = [];
      if (!item.addOnName?.trim()) {
        rowErrors.push('"Add-On Name" is empty');
      } else {
        if (item.addOnName.trim().length > 100) rowErrors.push('"Add-On Name" exceeds 100 characters');
      }
      if (!item.addOnCode?.trim()) {
        rowErrors.push('"Add-On Code" is empty');
      } else {
        if (item.addOnCode.trim().length > 60) rowErrors.push('"Add-On Code" exceeds 60 characters');
        if (!validateAlphanumeric(item.addOnCode.trim())) rowErrors.push('"Add-On Code" must be alphanumeric');
      }
      if (item.price?.trim()) {
        if (!isNumber(item.price)) rowErrors.push('"Price" must be a valid number');
        else if (parseFloat(item.price) < 1) rowErrors.push('"Price" must be at least 1');
      }
      if (item.active?.trim() && !isValidStatus(item.active)) rowErrors.push('"Active" must be Yes or No');
      if (rowErrors.length > 0) errors.push(`Row ${rowNum}: ${rowErrors.join(', ')}`);
    });
    if (errors.length > 0) {
      setValidationErrors(errors);
      setCsvValidateError(true);
      return;
    }
    const duplicateErrors = [];
    const newItems = filteredItemList.filter((item) => {
      const nameExists = addOnsList.findIndex((ch) => ch?.name?.trim()?.toLowerCase() === item?.addOnName?.trim()?.toLowerCase()) > -1;
      const codeExists = addOnsList.findIndex((ch) => ch?.code?.trim()?.toLowerCase() === item?.addOnCode?.trim()?.toLowerCase()) > -1;
      if (nameExists || codeExists) {
        const rowNum = item.__rowNum || '?';
        const reasons = [];
        if (nameExists) reasons.push(`name '${item.addOnName.trim()}'`);
        if (codeExists) reasons.push(`code '${item.addOnCode.trim()}'`);
        duplicateErrors.push(`Row ${rowNum}: Already exists (${reasons.join(' and ')})`);
        return false;
      }
      return true;
    });
    if (duplicateErrors.length > 0) duplicateErrors.forEach((e) => errors.push(e));
    if (newItems.length > 0) {
      const listToUpload = newItems.map((item) => ({
        hotelId,
        code: item?.addOnCode,
        name: item?.addOnName,
        price: parseInt(item?.price, 10) || 0,
        priceInDecimal: parseFloat(item?.price) || 0,
        status: item?.active?.trim()?.toUpperCase() === 'YES' ? true : false,
        restaurantId,
      }));
      setValidationErrors([]);
      setCsvValidateError(false);
      handleCsvDataSubmit(listToUpload);
    } else {
      setValidationErrors(errors);
      setCsvValidateError(true);
      setDataExistError(duplicateErrors.length > 0);
    }
  };

  const handleCsvDataSubmit = async (payloadLists) => {
    setCsvUploadStatus('uploading');
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';

      for (const payload of payloadLists) {
        const individualPayload = {
          ...payload,
          customAttributes: [],
        };
        await addInRoomDiningAddOn(individualPayload, language);
      }

      setCsvUploadStatus('success');
    } catch (e) {
      setCsvUploadErrorMsg(null);
      setCsvUploadStatus('server-error');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const generateHeaders = [
    { label: 'Add On Name', key: 'name' },
    { label: 'Add On Code', key: 'code' },
    { label: 'Price', key: 'priceInDecimal' },
    { label: 'Active', key: 'active' },
  ];

  const generateExportData = (itemsData) => {
    let tempList = itemsData?.map((e) => {
      const activeStatus = e?.status ? 'YES' : 'NO';

      return {
        ...e,
        active: `"${activeStatus}"`,
      };
    });

    const fields = ['name', 'code', 'priceInDecimal', 'active'];
    return tempList.map((record) =>
      Object.fromEntries(
        Object?.entries(record)?.filter(([key, value]) =>
          fields?.includes(key) ? [key, "'" + value] : null,
        ),
      ),
    );
  };

  const handleExport = () => {
    let selectedValue = addOnsList?.filter((addon) => addon?.isChecked);
    let exportData = [];
    let csvName = '';

    const propertyName = selectedHotel?.find((value) => value?.id === hotelId)?.name;

    if (selectedValue?.length === 1) {
      csvName = `${selectedValue[0].name}_ird_addon.csv`;
      exportData = generateExportData(selectedValue);
    } else if (selectedValue?.length > 1) {
      csvName = `${propertyName}_ird_addons.csv`;
      exportData = generateExportData(selectedValue);
    } else {
      csvName = `${propertyName}_ird_addons.csv`;
      exportData = generateExportData(addOnsList);
    }

    const headers = generateHeaders?.map((header) => header?.label);
    const csvContent = [
      headers.join(','),
      ...exportData?.map((addOn) =>
        generateHeaders?.map((header) => addOn[header.key] || '').join(','),
      ),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const anchor = document.createElement('a');
    anchor.href = window.URL.createObjectURL(blob);
    anchor.download = csvName;

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const handleAction = (actionName) => {
    let selectedAddon = addOnsList?.filter((addon) => addon?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedAddon?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedAddon?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedAddon?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      case 'Export':
        if (selectedAddon?.length > 0) {
          handleExport();
        }
        break;
      default:
        break;
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let index = addOnsList?.findIndex((addOn) => addOn.id === id);
    if (!addOnsList[index]?.isChecked) {
      addOnsList[index] = { ...addOnsList[index], isChecked: true };
    } else {
      addOnsList[index].isChecked = !addOnsList[index]?.isChecked;
    }
    setAddOnsList([...addOnsList]);

    let actionList = addOnsList
      ?.filter((addon) => addon?.isChecked)
      .map((status) => status?.status);

    const checkedItems = addOnsList?.filter((addon) => addon?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }
    if (!actionListName.includes('Export')) {
      actionListName.push('Export');
    }

    const isAllSelected = addOnsList?.every((addOn) => addOn?.isChecked);
    setIsAllSelected(isAllSelected);

    setActionMenuList(actionListName);
  };

  const handleSelectAll = (event) => {
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    let selectedAddonList = addOnsList?.map((addOn) => {
      return {
        ...addOn,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedAddonList?.some((addon) => addon?.status);
    const isInactive = selectedAddonList?.some((addon) => !addon.status);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }
    if (!actionListName.includes('Export')) {
      actionListName.push('Export');
    }

    setAddOnsList([...selectedAddonList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedAddonList.some((addOn) => addOn?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Add-on',
    listOfAddonIds?.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'IRD_ADDON';
      await updateSelectedItemsStatus(
        listOfAddonIds,
        hotelId,
        selectedLang,
        moduleName,
        restaurantId,
        isActive,
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'The status of the Add-on was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'IRD_ADDON';
      await deleteSelectedItems(
        listOfAddonIds,
        hotelId,
        selectedLang,
        moduleName,
        restaurantId,
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager('success', 'Addon deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : ' Failed to delete Add-on',
      );
    }
    setActionMenuList([]);
    setIsAllSelected(false);
  };

  useEffect(() => {
    updateSelectedModule(addOnsList, setActionMenuList, setIsAllSelected);
  }, [addOnsList]);

  useEffect(() => {
    if (inRoomDiningLoader || addOnsList?.length === 0) return;
    const totalItems = addOnsList?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [addOnsList?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== hotelId) {
      onsetPage(0);
    }
    prevHotelIdRef.current = hotelId;
  }, [hotelId]);

  const dragDisabled = isDragDisabled(addOnsList, searchText);

  return (
    <div className='mt-4 mb-4 group-list-container'>
      {warningPopup?.status && (
        <WarningPopup warningPopup={warningPopup} onWarningClose={onCloseWarning} />
      )}
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onDeleteItem}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      <Dialog fullScreen open={uploadState} onClose={handleUploadDialogClose}>
        <CsvUploader
          onClose={handleUploadDialogClose}
          pageTitle='Add-Ons'
          onFileReadingComplete={(e) => handleCsvFileData(e)}
          csvUploadStatus={csvUploadStatus}
          validFormatError={csvValidateError}
          setValidFormatError={setCsvValidateError}
          dataExistError={dataExistError}
          setDataExistError={setDataExistError}
          listName='Add-Ons'
          sectionTItle='Menu Configuration'
          csvUploadErrorMsg={csvUploadErrorMsg}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          downloadLink={DOWNLOAD_ASSETS_URL + '/cmsAssets/Menu+Configs+AddOn.xlsx'}
        />
      </Dialog>
      <SearchBar
        type={IN_ROOM_DINING_ADDONS_CREATE}
        buttonName='Add Add-ons'
        onOpenDrawer={onOpenDrawer}
        displayAddOrEdit={
          permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
            ? !isHideAddButton
              ? 'show'
              : 'hide'
            : 'hide'
        }
        setSearchText={handleSearchText}
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={addOnsList}
        setPlaceHolder={setAddOnsList}
        globalPlaceHolder={inRoomDiningAddOns}
        setGlobalPlaceHolder={setInRoomDiningAddOn}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='In-Room dining add-ons'
        module='IRD_ADDON'
        searchText={searchText}
        setSearch={setSearchText}
        extraSecondaryBtnDisplay={
          permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
        }
        extraSecondaryBtnText='Upload'
        onClickSecondaryBtn={onClickUpload}
        //temporary disable
        // exportBtn
        // exportBtnTitle="Export"
        // headers={generateHeaders}
        // exportData={generateExportData(addOnsList)}
        actionMenuItems={actionMenuList ?? []}
        handleAction={handleAction ?? false}
      />
      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loading || inRoomDiningLoader ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          addOnsList && (
            <TableContainer>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
                      <BulkActionCheckBox
                        onChange={handleSelectAll}
                        checked={isAllSelected || false}
                        selectedLength={selectedAddonLength}
                        totalLength={inRoomDiningAddOns?.length}
                        inputProps={{
                          'aria-label': 'select all Add-ons',
                        }}
                        className={PARTIAL_CHECKBOX_GREEN}
                      />
                    </TableCell>
                    <TableCell className='w-25'>Name</TableCell>
                    <TableCell className='w-25'>Code</TableCell>
                    <TableCell className='w-10' align='right'>
                      Price
                    </TableCell>
                    <TableCell className='w-30' align='center'>
                      Status
                    </TableCell>
                    <TableCell align='right'></TableCell>
                  </TableRow>
                </TableHead>

                <DragDropContext
                  onDragEnd={(event) =>
                    handleOnDragEnd(
                      event,
                      setVisible,
                      addOnsList,
                      setAddOnsList,
                      false,
                      page,
                      rowsPerPage,
                    )
                  }
                  isDropDisabled={dragDisabled}
                >
                  <Droppable droppableId='services' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? addOnsList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          : addOnsList
                        ).map((addOn, i) => (
                          <Draggable
                            key={addOn.id}
                            draggableId={addOn.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(provided) => (
                              <TableRow
                                key={i}
                                className='border-white pointer'
                                onClick={(e) => {
                                  onClickRowViewDetails(addOn, e);
                                }}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <TableCell className='w-12'>
                                  {!dragDisabled && (
                                    <span style={{ marginRight: 1.5 }}>
                                      <DragIndicator className='res-menu-accordion-drag' />
                                    </span>
                                  )}
                                  <Checkbox
                                    onChange={(event) => handleCheckboxChange(addOn?.id)}
                                    checked={addOn?.isChecked || false}
                                    inputProps={{
                                      'aria-label': `select addOn ${addOn.id}`,
                                    }}
                                  />
                                </TableCell>
                                <TableCell className='w-25'>{addOn?.name}</TableCell>
                                <TableCell className='w-25'>{addOn?.code}</TableCell>
                                <TableCell className='w-10' align='right'>
                                  {currency} {addOn?.priceInDecimal}
                                </TableCell>
                                <TableCell className='w-30' align='center'>
                                  <div className='d-flex justify-content-center'>
                                    <div
                                      className={`${
                                        addOn?.status ? 'pill-active ' : 'pill-inactive '
                                      } pill d-flex justify-content-center align-items-center`}
                                    >
                                      <span className='ms-1'>
                                        {!addOn?.status ? 'Inactive' : 'Active'}
                                      </span>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell align='right'>
                                  {permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] ===
                                    RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                    <Button
                                      aria-controls='simple-menu'
                                      aria-haspopup='true'
                                      onClick={(e) => {
                                        handleCellMenuClick(e, addOn);
                                      }}
                                      className='showpopupInner'
                                    >
                                      <MoreHoriz className='showpopupInner' />
                                    </Button>
                                  )}
                                  <Menu
                                    id={addOn.id}
                                    anchorEl={selectedValue?.anchorEl}
                                    disableRestoreFocus
                                    MenuListProps={{ autoFocusItem: false }}
                                    keepMounted
                                    open={
                                      Boolean(selectedValue.anchorEl) &&
                                      selectedValue.id === addOn.id
                                    }
                                    onClose={handleClose}
                                    className='shadow'
                                  >
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onToggleStatus(e);
                                      }}
                                    >
                                      {selectedValue.addOn && selectedValue.addOn.status ? (
                                        <>
                                          <RemoveCircleIcon className='me-2 action-menu-icon' />
                                          Deactivate
                                        </>
                                      ) : (
                                        <>
                                          <AddCircle className='me-2 action-menu-icon' />
                                          Activate
                                        </>
                                      )}
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onOpenDrawer(e, IN_ROOM_DINING_ADDONS_EDIT);
                                      }}
                                    >
                                      <CreateIcon className='me-2 action-menu-icon' />
                                      Edit
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => onViewDetails(addOn, e)}
                                    >
                                      <VisibilityIcon className='me-2 action-menu-icon' />
                                      View
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onClickDelete(e);
                                      }}
                                    >
                                      <DeleteForeverIcon className='me-2 action-menu-icon' />
                                      Delete
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={addOnsList.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}
        {showMultipleDeleteConfirmation && (
          <MultipleDeleteConfirmationPopup
            title={`Are you sure you want to ${actionName} this selection?`}
            subTitle={`A selection of ${selectedAddonLength} ${
              selectedAddonLength > 1 ? 'addons' : 'addon'
            } will be ${actionName}d. This Action is irreversible.`}
            isOpen={showMultipleDeleteConfirmation}
            onClose={() => setShowMultipleDeleteConfirmation(false)}
            onConfirm={() => {
              deleteMultipleSelection();
            }}
            leftButtonName={'Cancel'}
            rightButtonName={'Delete'}
          />
        )}

        {showBulkActiveDeactiveConfirmation && (
          <MultipleDeleteConfirmationPopup
            title={`Are you sure you want to ${actionName} this selection?`}
            subTitle={`A selection of ${selectedAddonLength}  ${
              selectedAddonLength > 1 ? 'addons' : 'addon'
            } will be ${actionName}d.`}
            isOpen={showBulkActiveDeactiveConfirmation}
            onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
            onConfirm={() => {
              handleMultipleStatusChange();
            }}
            leftButtonName={'No'}
            rightButtonName={'Yes'}
          />
        )}
        {showBulkSearchAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkSearchAlert}
            onClose={handleBulkSearchAlertClose}
            message="If you perform a search after making selections, the items you've selected will be lost."
            ButtonName='Cancel'
          />
        )}
        {showBulkKebabSelectionAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkKebabSelectionAlert}
            onClose={() => setShowBulkKebabSelectionAlert(false)}
            message='Please select one item from the list that you want to edit.'
            centerButtonName='OK'
          />
        )}
      </div>
    </div>
  );
};

export default AddonsListView;
